__turbopack_context__.v({
  "alternate-ui": "InviteHero-module__B58-kq__alternate-ui",
  "alternate-ui-gradient": "InviteHero-module__B58-kq__alternate-ui-gradient",
  "alternateUI": "InviteHero-module__B58-kq__alternateUI",
  "content": "InviteHero-module__B58-kq__content",
  "corporate-element": "InviteHero-module__B58-kq__corporate-element",
  "corporate-head": "InviteHero-module__B58-kq__corporate-head",
  "corporate-metrics": "InviteHero-module__B58-kq__corporate-metrics",
  "corporate-subtitle": "InviteHero-module__B58-kq__corporate-subtitle",
  "id-text": "InviteHero-module__B58-kq__id-text",
  "logo": "InviteHero-module__B58-kq__logo",
  "media-image": "InviteHero-module__B58-kq__media-image",
  "noise-bg": "InviteHero-module__B58-kq__noise-bg",
  "normalUI": "InviteHero-module__B58-kq__normalUI",
  "org-collab-tag": "InviteHero-module__B58-kq__org-collab-tag",
  "root": "InviteHero-module__B58-kq__root",
  "scaleAnim": "InviteHero-module__B58-kq__scaleAnim",
  "separator": "InviteHero-module__B58-kq__separator",
  "zomato": "InviteHero-module__B58-kq__zomato",
});
